import { render, staticRenderFns } from "./successful.vue?vue&type=template&id=2e18c44e&scoped=true"
import script from "./successful.vue?vue&type=script&lang=js"
export * from "./successful.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e18c44e",
  null
  
)

export default component.exports